import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { request, gql } from "graphql-request";
import { hyGraphToken, endpointURL } from "../ThemeModule";
import PageHeader from "../components/PageHeader";
import Seo from "../components/Seo";
import { toDescription } from "../seo/siteMeta.mjs";
const Page = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      const endpoint = endpointURL;
      const query = gql`
        query page($slug: String!) {
          page(where: { slug: $slug }) {
            title
            slug
            content {
                html
                text
            }
            component
          }
        }
      `;

      const headers = {
        Authorization: `Bearer ${hyGraphToken}`,
      };

      try {
        const data = await request(endpoint, query, { slug }, { headers });
        // Debug log
        setPost(data.page);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [slug]);

  return (
    <>
      {!loading && !post && (
        <Seo
          path={`/${slug}`}
          title="Page Not Found"
          description="The page you are looking for does not exist or has moved."
          noindex
        />
      )}
      {post && (
        <Seo
          path={`/${slug}`}
          title={post.title.trim()}
          description={toDescription(post.content?.text)}
        />
      )}

      <PageHeader title={post ? post.title : "Loading..."} />

      <div className="serviceDetail_page">
        <div className="max-w-container shape-1 shape-2 relative mx-auto px-4 pt-20 pb-20">
          {loading ? (
            <div className="loader text-center">Loading...</div>
          ) : error ? (
            <div className="error-message text-red-500 text-center">
              <p>Failed to load Service: {error}</p>
            </div>
          ) : (
            post && (
              <div className="mx-auto flex flex-wrap justify-center lg:px-5 lg:-mx-4">
                <div className="w-full lg:w-8/12 px-4">
                  <div className="page_content relative text-center">
                  {post.content?.html && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: post.content.html,
                      }}
                    />
                  )}
                  </div>
                </div>
               
              </div>
            )
          )}
        </div>
      </div>
    </>
  );
};

export default Page;
